import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import AddPremium from "../components/financeComponent/addPremiumComponent";

export default function AddPremiumPage() {
    return (
        <Layout>
            <Header/>
            <AddPremium/>
            <Footer/>
        </Layout>
    );
}